import { Button, Col, Container, Row, Stack } from "react-bootstrap";
import { Heading } from "@/ui/Heading";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";
import { useLink } from "@/hooks/useLink";
import clsx from "classnames";
import classes from "./styles.module.scss";
import Image from "@/ui/Image";

export const HiringPageDeliverSection = ({ className }) => {
  const locale = useLocale();
  const link = useLink();

  return (
    <div className={clsx(className, classes.deliver)}>
      <Container>
        <Heading>
          <DynamicText tag="h2" path={`page.hiring.deliver.title.${locale}`} />
        </Heading>
        <DynamicHtml path={`page.hiring.deliver.intro.${locale}`} className="mb-5" />
        <div className="mx-2">
          <Row>
            <Col xs={12} lg={6} className="bg-light py-4 ps-4 pe-3 py-md-5 ps-md-5 pe-md-4 text-overlay">
              <div className="text-overlay__content ms-0 ms-md-4">
                <DynamicText tag="h4" className="mb-4 mb-md-5" path={`page.hiring.deliver.section-1.title.${locale}`} />
                <DynamicHtml className="pb-4" path={`page.hiring.deliver.section-1.text.${locale}`} />
              </div>
              <Image
                className="text-overlay__background"
                img={{
                  path: "page.hiring.deliver.section-1.bg",
                  src: "/assets/grid/bg.png",
                }}
                size="642x"
                alt=""
              />
            </Col>
            <Col xs={12} lg={6} className="p-5">
              <Image
                img={{
                  path: "page.hiring.deliver.section-1.image",
                  src: "/assets/hiring/deliver/1.jpg",
                }}
                size="642x"
                alt=""
              />
            </Col>
            <Col xs={12} lg={6} className="bg-light py-4 ps-4 pe-3 py-md-5 ps-md-5 pe-md-4 text-overlay">
              <div className="text-overlay__content">
                <DynamicText path={`page.hiring.deliver.section-2.title.${locale}`} tag="h4" className="mb-4 mb-md-5" />
                <DynamicHtml path={`page.hiring.deliver.section-2.text.${locale}`} className="pb-md-5 mb-xl-5" />
              </div>
              <Image
                className="text-overlay__background"
                img={{
                  path: "page.hiring.deliver.section-2.bg",
                  src: "/assets/grid/bg.png",
                }}
                size="800x"
                alt=""
              />
            </Col>
            <Col xs={12} lg={6} className="p-5">
              <Image
                img={{
                  path: "page.hiring.deliver.section-2.image",
                  src: "/assets/hiring/deliver/2.jpg",
                }}
                size="800x"
                alt=""
              />
            </Col>
          </Row>
          <Row>
            <Stack className="flex-lg-row align-items-center px-0 py-4" gap={0}>
              <DynamicHtml path={`page.hiring.deliver.footer.${locale}`} className="flex-grow-1" />
              <div>
                <Button className="btn-outline-primary text-nowrap" href={link("contact")} tabIndex={undefined}>
                  <DynamicText path={`page.hiring.deliver.button.${locale}`} />
                </Button>
              </div>
            </Stack>
          </Row>
        </div>
      </Container>
    </div>
  );
};
